/** 
 * For ciudades selection - autocomplete.
 */
import { logger, dId } from "./utils.js";
import { search_type, ciudad_dropdown_furgo, ciudad_dropdown_turismo, ciudades_index } from "./variables.js";
import { validate_dropdown_ciudades } from "./validation.js";


let currentFocus: number;
let inp: HTMLInputElement;


/** Office autocomplete listeners 
 * attach once form officinas loaded 
**/
function add_ciudades_listeners() {

  logger("add autocomplete after JSON load", "log");
  autocomplete(<HTMLInputElement>dId("oficina_salida_selector"));
  autocomplete(<HTMLInputElement>dId("oficina_devolucion_selector"));

}


/**
 * 
 * @param input_id Imported from autocomplete function
 * Imported from library - not fully tested. Converted to TS(2023-12)
 */
function autocomplete(input_id: HTMLInputElement) {

  /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/

  const inp = input_id;

  inp.addEventListener("blur", function () {
    // Add a little delay to avoid error flash when dropdown populates field
    setTimeout(() => {
      logger("wait...");
      validate_dropdown_ciudades(this.id);
    }, 100);

  });

  // clear form if reclicked: 
  inp.addEventListener("focus", function () {
    this.value = "";

    // scroll this element to top of viewport: 
    if ( window.innerWidth < 768 ) {
      this.scrollIntoView({ behavior: "smooth", block: "start" });
    }

  });

  /*execute a function when someone writes in the text field:*/
  inp.addEventListener("input", function () {

    let arr = (search_type === "F") ? ciudad_dropdown_furgo : ciudad_dropdown_turismo;

    logger(arr.length + " posibilities");

    const val = this.value;

    /*close any already open lists of autocompleted values*/
    closeAllLists(null);
    if (!val) { return false; }
    currentFocus = -1;

    /*create a DIV element that will contain the items (values):*/
    const a = document.createElement("div");
    a.setAttribute("id", this.id + "autocomplete-list");
    a.setAttribute("class", "autocomplete-items");

    /*append the DIV element as a child of the autocomplete container:*/
    (<HTMLElement>this.parentNode).appendChild(a);
    /*for each item in the array...*/
    for (let i = 0; i < arr.length; i++) {

      /* Search for text entered:  */
      let s = arr[i].toUpperCase().search(val.toUpperCase());
      
      if (s >= 0) {

        /*create a DIV element for each matching element:*/
        const b = document.createElement("div");
        let matched_text = ""; 


        /* Make the matching letters bold: */
        matched_text = arr[i].substring(0, s);
        matched_text += "<strong>" + arr[i].substring(s, (s + val.length) ) + "</strong>";
        matched_text += arr[i].substring(s + val.length, arr[i].length);

        b.innerHTML = matched_text; 

        /*insert a input field that will hold the current array item's value:*/
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";

        /*execute a function when someone clicks on the item value (DIV element):*/
        b.addEventListener("click", function (e) {

          let res:string = this.getElementsByTagName("input")[0].value;

          inp.value = res;
          closeAllLists(null);

          // Delay validation to avoid pink error flash:
          validate_dropdown_ciudades(inp.id);


        });
        a.appendChild(b);
      }
    }
  });


  /*execute a function presses a key on the keyboard:*/
  inp.addEventListener("keyup", function (e) {
    const x_inp = dId(this.id + "autocomplete-list");
    let x: Array<HTMLDivElement> = [];

    if (x_inp) {
      x = Array.from(x_inp.getElementsByTagName("div"));
    }

    if (e.key === "ArrowDown") {
      /*If the arrow DOWN key is pressed,
      increase the currentFocus variable:*/
      currentFocus++;
      /*and and make the current item more visible:*/
      addActive(x);
    } else if (e.key === "ArrowUp") {
      /*If the arrow UP key is pressed,
      decrease the currentFocus variable:*/
      currentFocus--;
      /*and and make the current item more visible:*/
      addActive(x);
    } else if (e.key === "Enter") {
      /*If the ENTER key is pressed, prevent the form from being submitted,*/
      e.preventDefault();
      if (currentFocus > -1) {
        /*and simulate a click on the "active" item:*/
        if (x) x[currentFocus].click();
      }
    }
  });

  /*execute a function when someone clicks in the document:*/
  document.addEventListener("click", function (e) {
    closeAllLists(e.target);
  });




  function addActive(x: Array<HTMLElement>) {
    /*a function to classify an item as "active":*/
    if (!x) return false;

    /*start by removing the "active" class on all items:*/
    removeActive(x);

    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = (x.length - 1);

    /*add class "autocomplete-active":*/
    x[currentFocus].classList.add("autocomplete-active");
  }

  function removeActive(x: Array<Element>) {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove("autocomplete-active");
    }
  }

  function closeAllLists(elmnt: EventTarget | null) {
    /*close all autocomplete lists in the document,
    except the one passed as an argument:*/
    var x = document.getElementsByClassName("autocomplete-items");
    for (var i = 0; i < x.length; i++) {
      if (elmnt != x[i] && elmnt != inp) {
        if (x[i].parentNode !== null) {
          (<HTMLElement>x[i].parentNode).removeChild(x[i]);
        }
      }
    }
  }


}


export { autocomplete, add_ciudades_listeners};